import React from "react";

import { css } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { BirthDateFormField } from "@/uiKit/molecules/PatientCreationAndRenewal/BirthDateFormField.tsx";
import { PrescriptionUploadField } from "@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/FormFields/PrescriptionUploadField.tsx";

export type PrescriptionInfoFormContentProps = {
  patientInfo: {
    givenName: string;
    familyName: string;
  };
  carePlanStartDate: string;
};

export const PrescriptionInfoFormContent: React.FC<PrescriptionInfoFormContentProps> = ({
  patientInfo,
  carePlanStartDate,
}) => {
  const styles = useStyles(makeStyles);

  return (
    <CardContent formExtraPadding className={styles.container}>
      <BirthDateFormField />
      <PrescriptionUploadField patientInfo={patientInfo} carePlanStartDate={carePlanStartDate} />
    </CardContent>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(8)};
    width: 100%;
  `,
});
